import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import React from "react";
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import EditForm from "../../../components/product/form/edit";
import {useTranslation} from "next-i18next";
import MetaData from "../../../components/metadata";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Keyboard()
{
    // init
    const { t } = useTranslation();

    // render
    return (
        <>
            {/* Metadata */}
            <MetaData
                type={'website'}
                title={t('add.product.keyboard')}
                description={t('add.product.keyboard.lead', { ns: 'glossary' })}
                keywords={[t('add.product.keyboard')]}
                imageURL={process.env.logoURL}
            />

            {/* Header */}
            <Header />

            {/* Form */}
            <EditForm
                title={t('add.product.keyboard')}
                buttonText={t('add.product')}
                successAlert={t('add.product.success', { ns: 'glossary' })}
                errorAlert={t('add.product.failure', { ns: 'glossary' })}
                type={''}
                code={''}
                manufacturer={''}
                productName={''}
                amount={''}
                quantity={''}
                unit={''}
                images={[]}
                allImages={[]}
                nutrients={[]}
                ingredients={[]}
                traces={[]}
                stores={[]}
                labels={[]}
            />

            {/* Footer */}
            <Footer />
        </>
    );
}

/**
 *
 * @param context
 * @returns {Promise<{props: {}}>}
 */
export async function getStaticProps(context) {
    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'units'])),
        }
    };
}